import axios from 'axios'
import notifService from '../../services/notifService'

export const getTicket = async (context, pagination) => {
  let res = await axios
    .get('/cross/tickets/complaint', {
      params: pagination
    })
    .then(response => {
      context.commit('getTicket', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })

  return res
}

export const getTicketDetail = async (context, id) => {
  let res = await axios
    .get('/cross/tickets/' + id)
    .then(response => {
      context.commit('getTicketDetail', response.data.data)

      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getTicketChat = async (context, id) => {
  let res = await axios
    .get('/cross/tickets/chat/' + id)
    .then(response => {
      context.commit('getTicketChat', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })

  return res
}

export const getTicketAttachment = async (context, id) => {
  let res = await axios
    .get('/cross/tickets/attachment/' + id)
    .then(response => {
      context.commit('getTicketAttachment', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })

  return res
}

export const responseReply = async (context, val) => {
  let res = await axios
    .post('/cross/tickets/chat/response/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}
export const responseSolved = async (context, val) => {
  let res = await axios
    .post('/cross/tickets/chat/solve/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}
